const $ = jQuery.noConflict();
import FormHelpers from './formHelpers';

'use strict';
const Append = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeaderNavInner: $('.js-nav-inner'),
	$domHeaderNavBanner: $('.js-site-header__menu-item-info-banner'),
	$domSiteHeader: $('.js-site-header'),

	/** @description Initialize */
	init: function() {
		// this.appendComponents();
		$('<span class="header-category-lines"></span>').appendTo($('.menu-item--spec'));
		// $(window).on('load', function() {
		// 	$('.js-site-header__menu-item-info-banner').css('display', 'flex');
		// });
		// $(document).on('load', function() {
		// 	$('.js-site-header__menu-item-info-banner').css('display', 'flex');
		// });
		$('.single-product-gift').on('click', function() {
			$('.single-product-gift span').addClass('is-visible');
			setTimeout(function(){
				$('.single-product-gift span').removeClass('is-visible');
			}, 3000);
		});
		jQuery('body').on('checkout_error', function(){
			FormHelpers.$domBtnLoader.removeClass(FormHelpers.classVisible);
		});
	},

	appendComponents: function() {
		if ($(window).width() < 1183) {
			Append.$domHeaderNavBanner.appendTo(Append.$domHeaderNavInner);
		} else {
			Append.$domHeaderNavBanner.appendTo($('.menu-item--spec > .sub-menu'));
		}
		$(window).on('resize', function() {
			if ($(window).width() < 1183) {
				Append.$domHeaderNavBanner.appendTo(Append.$domHeaderNavInner);
			} else {
				Append.$domHeaderNavBanner.appendTo($('.menu-item--spec > .sub-menu'));
			}
		});
	},
};

export default Append;